// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-cube-meta.ts
import type {
  CubeMeasureEntry,
  CubeDimensionEntry,
  CubeJoinEntry
} from 'shared/src/api/cube-api-types';

export const creativesCubeMeta = {
  name: 'creatives',
  sqlTable: 'media_tool.creatives',
  title: 'Creatives',
  joins: {
    campaigns: { relationship: 'many_to_one' } as const satisfies CubeJoinEntry
  },
  measures: {
    'creatives.count': {
      type: 'number',
      aggType: 'count',
      title: 'Creative Count',
      description: 'Number of creatives',
      meta: {
        category: 'utility',
        supports_rollup: true,
        formula: 'COUNT(*)',
        inputs: [],
        short_description: 'Number of creatives',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeMeasureEntry
  },
  dimensions: {
    'creatives.id': {
      sql: 'id',
      type: 'string',
      title: 'Creative ID',
      primaryKey: true,
      meta: {
        short_description: 'Zoho CRM Creative ID',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.name': {
      sql: 'name',
      type: 'string',
      title: 'Creative Name',
      meta: {
        short_description: 'Creative display name',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.account_name': {
      sql: 'account_name',
      type: 'string',
      title: 'Account Name',
      meta: {
        short_description: 'Associated account name',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.media_campaign_id': {
      sql: 'media_campaign_id',
      type: 'string',
      title: 'Media Campaign ID',
      meta: {
        short_description: 'Linked campaign/deal ID',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.owner_id': {
      sql: 'owner_id',
      type: 'string',
      title: 'Owner ID',
      meta: {
        short_description: 'Zoho user ID of the creative owner',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.creative_setup_type': {
      sql: 'creative_setup_type',
      type: 'string',
      title: 'Creative Setup Type',
      meta: {
        short_description: 'Type of creative setup',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.status': {
      sql: 'status',
      type: 'string',
      title: 'Status',
      meta: {
        short_description: 'Current creative status',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.creative_addition': {
      sql: 'creative_addition',
      type: 'string',
      title: 'Creative Addition',
      meta: {
        short_description: 'Creative addition details',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.creative_swap': {
      sql: 'creative_swap',
      type: 'string',
      title: 'Creative Swap',
      meta: {
        short_description: 'Creative swap details',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.additional_notes': {
      sql: 'additional_notes',
      type: 'string',
      title: 'Additional Notes',
      meta: {
        short_description: 'Additional notes for the creative',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.creative_naming_convention_for_reporting': {
      sql: 'creative_naming_convention_for_reporting',
      type: 'string',
      title: 'Naming Convention for Reporting',
      meta: {
        short_description: 'Reporting naming convention for the creative',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.creative_click_thru_urls': {
      sql: 'creative_click_thru_urls',
      type: 'string',
      title: 'Click-Through URLs',
      meta: {
        short_description: 'Creative click-through URL destinations',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.created_time': {
      sql: 'created_time',
      type: 'time',
      title: 'Created Time',
      meta: {
        short_description: 'Timestamp when the creative was created',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry,
    'creatives.modified_time': {
      sql: 'modified_time',
      type: 'time',
      title: 'Modified Time',
      meta: {
        short_description: 'Last modified timestamp from Zoho CRM',
        source_tables: ['media_tool.creatives']
      }
    } as const satisfies CubeDimensionEntry
  }
};
